

import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import type { SellerInviteResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type ReissueSellerInviteInput = {
  sellerId: string;
};

export function useReissueSellerInviteMutation() {
  const mutation = useMutation({
    mutationFn: ({ sellerId }: ReissueSellerInviteInput) =>
      apiJsonClient<SellerInviteResponse>(endpoints.admin.sellerInvite(sellerId), {
        method: "POST",
      }),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
